import type { ProPlanKey } from "@/lib/pro-pricing";

/**
 * Paid features unlock on every paid plan; only the free tier (null plan) is
 * locked out. Pass the viewer's active plan key (null on the free tier).
 *
 * The ladder meters volume, not features: Starter, Growth, and Scale all reach
 * every tab, and differ in how many websites and prompts they track and which
 * models answer them (see PLAN_ENTITLEMENTS). So this is a null check, not a
 * tier comparison: adding a cheaper tier must never lock a feature that a
 * pricier one already sold.
 *
 * There is deliberately no per-segment nav lock anymore: every dashboard
 * section has a free state (real data, in-page upsell at the point where paid
 * value begins), so gating lives in each feature's server payload and content
 * component, not in the sidebar.
 */
export function hasAdvancedAccess(
	plan: ProPlanKey | null | undefined,
): boolean {
	return plan != null;
}
